const translation = {
  custom: 'Personalizzazione',
  upgradeTip: {
    prefix: 'Aggiorna il tuo piano per',
    suffix: 'personalizzare il tuo marchio.',
    title: 'Aggiorna il tuo piano',
    des: 'Aggiorna il tuo piano per personalizzare il tuo marchio',
  },
  webapp: {
    title: 'Personalizza il marchio web app',
    removeBrand: 'Rimuovi Powered by Dify',
    changeLogo: 'Cambia immagine del marchio Powered by',
    changeLogoTip: 'Formato SVG o PNG con una dimensione minima di 40x40px',
  },
  app: {
    title: 'Personalizza l\'intestazione del marchio dell\'app',
    changeLogoTip: 'Formato SVG o PNG con una dimensione minima di 80x80px',
  },
  upload: 'Carica',
  uploading: 'Caricamento in corso',
  uploadedFail: 'Caricamento dell\'immagine fallito, per favore ricarica.',
  change: 'Cambia',
  apply: 'Applica',
  restore: 'Ripristina Impostazioni Predefinite',
  customize: {
    contactUs: ' contattaci ',
    prefix:
      'Per personalizzare il logo del marchio all\'interno dell\'app, per favore',
    suffix: 'per aggiornare alla versione Enterprise.',
  },
}

export default translation
